jQuery(document).ready(function ($) {
    const search = $('.property-search');

    search.each(function () {
        const this_search = $(this);

        const params = $(this).find('.property-search__param');
        const dropdowns = params.find('.options');
        const options = params.find('.option');
        const resets = params.find('.reset');
        const toggles = params.find('.toggle');

        const properties_views = $(this).parent().parent().parent().next();

        const sort = properties_views.find('.sort');
        //const sort = $('.sort');
        const sort_dropdown = sort.find('.options');
        const sort_options = sort.find('.option');

        const commercial_types = $('.commercial-type');
        const commercial_types_dropdown = commercial_types.find('.options');
        const commercial_types_options = commercial_types.find('.option');

        const count = $('#properties-count');

        let ajax = false;

        let filters = '';
        let page = 1;

        $.fn.getDepartment = function () {
            if (this.hasClass('department-student')) {
                return 'student';
            }

            if (this.hasClass('department-residential')) {
                return 'residential';
            }

            if (this.hasClass('department-commercial')) {
                return 'commercial';
            }

            return 'all';
        }

        const department = $('body').getDepartment();

        $.fn.getLocationTaxonomyData = function (filters) {
            const param = this.attr('data-param');
            const selected = this.find('.selected');

            if (param === 'location') {
                const taxonomy = selected.attr('data-taxonomy');
                filters.push(`taxonomy:${taxonomy}`);

                const term_id = selected.attr('data-term-id');
                filters.push(`term_id:${term_id}`);
            }
        }

        $.fn.getSelectedFilters = function () {
            if (this_search.length === 0 && commercial_types.length === 0) {
                return this;
            }

            let filters_array = [];

            if ($('.properties-intro').length > 0) {
                if ($('.properties-intro').attr('data-extra-filters')) {
                    filters_array.push($('.properties-intro').attr('data-extra-filters'));
                }
            }

            console.log(this.find('.property-search__param:visible'));

            this.find('.property-search__param:visible').each(function () {
                const param = $(this).attr('data-param');
                const selected = $(this).find('.selected').attr('data-value');

                filters_array.push(`${param}:${selected}`);

                $(this).getLocationTaxonomyData(filters_array);
            });

            // Include hidden params (fixed taxonomy context, e.g. current location/student_apartment term)
            this.find('.property-search__param:hidden').each(function () {
                const param = $(this).attr('data-param');
                const selected = $(this).find('.selected').attr('data-value');
                if (selected) {
                    filters_array.push(`${param}:${selected}`);
                }
            });

            if (sort.length > 0) {
                let param = sort.attr('data-param');
                let selected = sort.find('.selected').attr('data-value');

                filters_array.push(`${param}:${selected}`);

                $(this).getLocationTaxonomyData(filters_array);
            }

            if (commercial_types.length > 0) {
                let param = commercial_types.attr('data-param');
                let selected = commercial_types.find('.selected').attr('data-value');

                filters_array.push(`${param}:${selected}`);
            }

            filters = JSON.stringify(filters_array);

            console.log(filters);

            return this;
        }

        $.fn.isAjax = function () {
            if (this_search.length === 0 && commercial_types.length === 0) {
                return this;
            }

            const method = $(this).attr('data-method');

            if (method === 'ajax') {
                ajax = true;
            }

            return this;
        }

        $.fn.getProperties = function (append) {
            if (this_search.length === 0 && commercial_types.length === 0) {
                return this;
            }

            const data = {
                department: department,
                filters: filters,
                page: page,
                action: 'search_properties',
                nonce: properties.nonce
            }

            console.log(data);

            $.ajax({
                url: properties.ajax_url,
                type: 'POST',
                data: data,

                beforeSend: function () {
                    console.log('searching for properties...');
                    if (!append) {
                        $('.properties-grid').find('.loading span').text('Getting properties and generating map...');
                    }
                    $('.properties-grid').find('.loading').fadeIn(250);
                    if (append) {
                        $('#load-more').prop('disabled', true).text('Loading properties...');
                    }
                },

                success: function (response) {
                    console.log(response);

                    if (append) {
                        $('.properties-grid__container').append(response.data.html);
                    } else {
                        $('.properties-grid__container').html(response.data.html);
                        $('.properties-map__container').next().remove();
                        $('.properties-map__container').replaceWith(response.data.map);
                        initMap();
                    }

                    if (response.data.count !== null) {
                        count.updateCount(response.data.count);
                    }
                    initPropertySwipers();

                    if (response.data.has_more) {
                        $('#load-more').show();
                    } else {
                        $('#load-more').hide();
                    }
                },

                complete: function () {
                    console.log('complete!')
                    $('.properties-grid').find('.loading').fadeOut(250);
                    $('.properties-grid').find('.loading span').text('');
                    if (append) {
                        $('#load-more').prop('disabled', false).text('Load More');
                    }
                }
            });

            return this;
        }

        //search.isAjax().getSelectedFilters().getProperties();
        this_search.isAjax().getSelectedFilters();

        if (commercial_types.length > 0) {
            commercial_types.isAjax().getSelectedFilters();
        }

        this_search.on('change', function (event) {
            resets.changeResets();

            console.log('ajax');

            page = 1;

            if (ajax) {
                $(this).getSelectedFilters().getProperties(false);
            }
        });


        commercial_types.on('change', function (event) {
            page = 1;

            if (ajax) {
                commercial_types.getSelectedFilters().getProperties(false);
            }

        });

        $.fn.changeResets = function () {
            this.each(function () {
                const selected = $(this).parent().prev();

                const value = selected.attr('data-value');
                const defaultValue = selected.attr('data-default-value');

                //console.log([value, defaultValue]);

                if (value === defaultValue) {
                    $(this).next().show();
                    $(this).hide();
                }
                else {
                    $(this).show();
                    $(this).next().hide();
                }
            });

            return this;
        }

        function triggerChange() {
            resets.trigger('change');
        }

        function toggleDropdown(event) {
            event.stopPropagation();

            dropdowns.not($(this).find('.options')).removeClass('active').hide();
            sort_dropdown.not($(this).find('.options')).removeClass('active').hide();

            $(this).toggleClass('active');

            $(this).find('.options').toggle();
        }

        params.on('click', toggleDropdown);

        sort.on('click', toggleDropdown);

        commercial_types.on('click', toggleDropdown);

        // Hide option dropdowns when clicking off
        $(document).on('click', function (event) {
            if (!dropdowns.is(event.target) && dropdowns.has(event.target).length === 0) {
                dropdowns.hide();
            }
            if (!sort_dropdown.is(event.target) && sort_dropdown.has(event.target).length === 0) {
                sort_dropdown.hide();
            }
            if (!commercial_types_dropdown.is(event.target) && commercial_types_dropdown.has(event.target).length === 0) {
                commercial_types_dropdown.hide();
            }
        });

        function button_get_params(event) {
            event.preventDefault();

            const previous_params = $(this).closest('.search__view').find('.property-search > .property-search__param:visible');
            let query = '?';

            previous_params.each(function () {
                query += $(this).attr('data-param') + "=" + $(this).find('.selected').attr('data-value') + '&';
            });

            $(this).closest('.property-search').find('.property-search__filters .property-search__param').each(function () {
                if ($(this).closest('.search__view').find(`.property-search > .property-search__param[data-param="${$(this).attr('data-param')}"]:hidden`).length > 0) {
                    query += $(this).attr('data-param') + "=" + $(this).find('.selected').attr('data-value') + '&';
                }
            });

            const button_url = $(this).attr('href').replace(/^([^?]+)\?(.*?)$/, '$1' + query.slice(0, -1));

            console.log(button_url);

            $(this).attr('href', button_url);
        }

        this_search.find('.button').on('change', button_get_params);

        function option_click(event) {
            event.stopPropagation();

            const value = $(this).attr('data-value');
            const label = $(this).text();

            let selected = $(this).parent().prev().prev();

            selected.attr('data-value', value);
            selected.text(label);

            $(this).parent().parent().parent().removeClass('active');

            dropdowns.hide();
            sort_dropdown.hide();
            commercial_types_dropdown.hide();

            if ($(this).closest('.property-search').attr('data-method') === 'button') {
                $(this).closest('.property-search').find('.button').trigger('change');
                return;
            }

            this_search.trigger('change');

            if (commercial_types.length > 0) {
                commercial_types.trigger('change');
            }
        }

        options.on('click', option_click);

        sort_options.on('click', option_click);

        commercial_types_options.on('click', option_click);

        toggles.on('click', function (event) {
            event.preventDefault();
            //event.stopPropagation();
        });

        resets.on('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            dropdowns.hide();

            const selected = $(this).parent().prev();

            const defaultValue = selected.attr('data-default-value');
            const defaultLabel = selected.attr('data-default-label');

            selected.attr('data-value', defaultValue);
            selected.text(defaultLabel);

            this_search.trigger('change');

            if (commercial_types.length > 0) {
                commercial_types.trigger('change');
            }
        });

        $.fn.updateCount = function (count) {
            count = parseInt(count);
            let label = count;

            if (count === 0) {
                label = 'No Properties Found';
            }
            else if (count === 1) {
                label += ' Property Found';
            }
            else {
                label += ' Properties Found';
            }

            this.attr('data-count', count);
            this.text(label);
            return this;
        }

        $.fn.getCount = function () {
            return parseInt(this.attr('data-count'));
        }

        $(this).find('.property-search__mobile--button').on('click', function (event) {
            event.preventDefault();

            const top = $('.site-header').position().top + $('.site-header').height() + 20;
            const max_height = 'calc(100vh - ' + top + ' - 20)';

            if ($(window).width() < 1024) {
                $(this).next().css({
                    'top': top + 'px',
                    'max-height': max_height
                });
            } else {
                $(this).next().css({
                    'top': 'calc(100% + 1.25rem)',
                    'max-height': 'none'
                });
            }
            $(this).next().fadeToggle(250);
        });

        $(this).find('.property-search__filters--close').on('click', function (event) {
            event.preventDefault();

            $(this).closest('.property-search__filters').fadeOut(250);
        });

        $(this).find('.property-search__filters--apply').on('click', function (event) {
            event.preventDefault();

            $(this).closest('.property-search__filters').fadeOut(250);
        });

        $(window).on('resize', function () {
            $('.property-search__filters').hide();
        });

        $('body').on('click', function (event) {
            if (!($(event.target).closest('.property-search__param').length > 0 || $(event.target).hasClass('property-search__param--dropdown'))) {
                dropdowns.hide();
                sort_dropdown.hide();
            }
        });

        $('#load-more').off('click').on('click', function (event) {
            event.preventDefault();
            if ($(this).prop('disabled')) return;
            page++;
            this_search.getSelectedFilters().getProperties(true);
        });

        if (ajax) {
            $(this).getSelectedFilters().getProperties(false);
        }
    })

    function initPropertySwipers() {
        $('.js-property-grid-item-gallery').each(function () {
            const selector = `.js-property-grid-item-gallery[data-property-id="${$(this).attr('data-property-id')}"]`;

            const swiper = new Swiper(selector, {
                loop: true,
                slidesPerView: 1,
                autoplay: false,
                navigation: {
                    prevEl: '.property-grid-item__prev',
                    nextEl: '.property-grid-item__next'
                },
                pagination: {
                    el: '.property-grid-item__pagination',
                    bulletClass: 'property-grid-item__bullet',
                    bulletActiveClass: 'active'
                },
                slideClass: 'property-grid-item__image'
            });

            $(selector).on('mouseenter', function () {
                swiper.params.autoplay = { delay: 3000, disableOnInteraction: false };
                swiper.autoplay.start();
            }).on('mouseleave', function () {
                swiper.autoplay.stop();
            });
        });

        $('.js-property-item').each(function () {
            new Swiper(`.js-property-item[data-property-id="${$(this).attr('data-property-id')}"]`, {
                loop: true,
                slidesPerView: 1,
                autoplay: true,
                delay: 3000,
                navigation: {
                    prevEl: '.property-item__prev',
                    nextEl: '.property-item__next'
                },
                pagination: {
                    el: '.property-item__pagination',
                    bulletClass: 'property-item__bullet',
                    bulletActiveClass: 'active'
                },
                slideClass: 'property-item__image',
                on: {
                    slideChange: function (swiper) {
                        var img = swiper.slides[swiper.activeIndex].querySelector('img[data-src]');
                        if (img) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
                    }
                }
            });
        });
    }
});